import { COUPONS_PATH_A } from '@constant'
import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'
import { isStandard, isUltimate } from '@merchant-backend/util'
import { notUltimateAlert } from '@util'
import React, { Component } from 'react'
import style from '../../style.module.less'

export default class extends Component {
  checkMerchant = () => {
    if (isUltimate() || isStandard()) {
      window.location.href = `${COUPONS_PATH_A}/detail`
    } else {
      notUltimateAlert()
    }
  }

  render() {
    return (
      <div className={style.introduction}>
        {/*<img src="http://qnm.hunliji.com/o_1b0i9rd8ektr1pvs1s932tv6m7.jpg" />*/}
        <img
          src="https://qnm.hunliji.com/o_1dn75c0bq1qnq14k41pkg1i9prth9.jpg"
          style={{ width: '100%' }}
        />
        <div>
          <span onClick={this.checkMerchant}>+创建优惠券</span>
        </div>
        <div style={{ color: '#508cee', fontSize: 14 }}>
          <p>如有疑问请拨打：{MERCHANT_CONSULT_PHONE}</p>
        </div>
      </div>
    )
  }
}
